var $ = require('jquery');

$(document).ready(function () {
    headerStickyWith703Bar();
});

function headerStickyWith703Bar() {
    var deviceViewport = 991;
    var headerBottomGap = 80;
    if ($(".cc-productbarposition").length) {
        var headerHeight = $('.header')[0].clientHeight;

        if ($('.breadcrumb').innerHeight()) {
            var productBarHeight = $('.cc-productbarposition').innerHeight();

            $('.cc-productbarposition').css({
                'top': headerHeight + 'px'
            });

            if ($(".header__position").css("position") == "fixed" && $('.header-wrapper')) {
                $('.header-wrapper').css({
                    'height': ($(window).width() > deviceViewport) ? headerHeight + productBarHeight : headerHeight + 'px'
                });
            }
        } else {
            $('.cc-productbarposition').css({
                'top': headerHeight + 'px'
            });
            $('.header-wrapper').css({ 'margin-bottom': ($(window).width() > deviceViewport) ? headerBottomGap : 0 + 'px' });
        }
    }
}

$(function () {
    var prevScrollpos = window.pageYOffset;
    var scrollTimer, lastScrollFireTime = 0;
    var headerHeight = $('.header')[0].clientHeight;

    $(window).on('resize orientationchange', function () {
        $('.cc-productbarposition').css({
            'top': 0 + 'px'
        });

        setTimeout(function() {
                headerHeight = $('.header')[0].clientHeight;
                $('.cc-productbarposition').css({
                    'top': headerHeight + 'px'
                });
                headerStickyWith703Bar();
            }, 300);
    });

        $(window).scroll(function() {
            var minScrollTime = 100;
            var now = new Date().getTime();

            function processScroll() {
                var currentScrollPos = window.pageYOffset;
                if (document.getElementById('header') && document.getElementById('header').scrollHeight) {
                    if (document.getElementById('header').scrollHeight < prevScrollpos) {
                        //scroll up vs down
                        if (prevScrollpos >= currentScrollPos) {
                            $('.cc-productbarposition').css({
                                'top': headerHeight + 'px'
                            });
                        } else {
                            $('.cc-productbarposition').css({
                                'top': '0px'
                            });
                        }
                    } else {
                        $('.cc-productbarposition').css({
                            'top': headerHeight + 'px'
                        });
                    }
                    prevScrollpos = currentScrollPos;
                }
            }

            if (navigator.userAgent.match(/Trident\/7\./)) { // if IE
                //ie11 keeps firing multiple scroll events that cause inconsistency in scroll height. Have to throttle the events
                if (!scrollTimer) {
                    if (now - lastScrollFireTime > (3 * minScrollTime)) {
                        processScroll(); // fire immediately on first scroll
                        lastScrollFireTime = now;
                    }
                    scrollTimer = setTimeout(function() {
                            scrollTimer = null;
                            lastScrollFireTime = new Date().getTime();
                            processScroll();
                        },
                        minScrollTime);
                }
            } else {
                processScroll();
            }
        });
});

